import { Button, IconCloseDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import { useFab } from './FabProvider'
import { FloatingActionContent } from './FloatingActionContent'
import { CONCIERGE_EXPERIENCE_I18N_NAMESPACE } from '../i18n/i18nInstance'

export const FloatingAction = () => (
  <>
    <FloatingActionContent />
    <FloatingActionButton />
  </>
)

const FloatingActionButton = () => {
  const { isConciergeOpened, toggleConcierge } = useFab()

  return (
    <div className='d-flex justify-content-end mc-mr-6'>
      <div>
        <Button
          kind='control'
          onClick={() => toggleConcierge({ track: true })}
          size='lg'
          style={{ width: '48px', height: '48px' }}
        >
          {isConciergeOpened ? <CloseIcon /> : <OpenIcon />}
        </Button>
      </div>
    </div>
  )
}

const CloseIcon = () => {
  const { t } = useTranslation(CONCIERGE_EXPERIENCE_I18N_NAMESPACE)

  return <IconCloseDefault size='md' srText={t('fab.icon.closeSrText')} />
}

const OpenIcon = () => {
  const { t } = useTranslation(CONCIERGE_EXPERIENCE_I18N_NAMESPACE)

  return (
    <p style={{ fontSize: '28px' }} aria-label={t('fab.icon.openSrText')}>
      ?
    </p>
  )
}
